const action12 = {
    svg: '<svg style="width:0.75rem; height:0.75rem;" viewBox="0 0 12 12"><path d="M5.96 8.58a.96.96 0 1 1 0 1.92.96.96 0 0 1 0-1.92m0-3.54a.96.96 0 1 1 0 1.92.96.96 0 0 1 0-1.92m0-3.54a.96.96 0 1 1 0 1.92.96.96 0 0 1 0-1.92"/></svg>',
};

export { action12 as default };
